// src/pages/Galerie.js
import React, { useState, useMemo } from "react";
import "../index.css";
import useSEO from "../seo/useSEO";

// 📸 Liste d'images — adapte les chemins à ton arborescence
const IMAGES = [
  { src: "/images/gallery/photo1.jpg",  alt: "Un Produit",  caption: "Restaurant Grünewald Chef's Table" },
  { src: "/images/gallery/photo2.jpg",  alt: "Un Moment",   caption: "Restaurant Archibald De Prince" },
  { src: "/images/gallery/photo3.jpg",  alt: "Un Lieu",     caption: "Restaurant Chez Doudou" },
  { src: "/images/gallery/photo4.jpg",  alt: "Un Portrait", caption: "Le 27G" },
  { src: "/images/gallery/photo5.jpg",  alt: "Un Moment",   caption: "Restaurant Chez Doudou" },
  { src: "/images/gallery/photo6.jpg",  alt: "Un Lieu",     caption: "Restaurant Archibald De Prince" },
  { src: "/images/gallery/photo7.jpg",  alt: "Un Produit",  caption: "L'Atelier du Burger" },
  { src: "/images/gallery/photo8.jpg",  alt: "Un Portrait", caption: "Alexandre POLMARD" },
  { src: "/images/gallery/photo9.jpg",  alt: "Un Produit",  caption: "Restaurant Le Capu" },
  { src: "/images/gallery/photo10.jpg", alt: "Un Moment",   caption: "Le Moulin de la Piérie" },
  { src: "/images/gallery/photo11.jpg", alt: "Un Produit",  caption: "Traiteur Marcotullio" },
  { src: "/images/gallery/photo12.jpg", alt: "Un Produit",  caption: "Parc d'attraction Nigloland" },
  { src: "/images/gallery/photo13.jpg", alt: "Un Moment",   caption: "Gault & Millau Luxembourg" },
  { src: "/images/gallery/photo14.jpg", alt: "Un Produit",  caption: "Hotel Le Place d'Armes" },
  { src: "/images/gallery/photo15.jpg", alt: "Un Produit",  caption: "Restaurant Grünewald Chef's Table" },
  { src: "/images/gallery/photo16.jpg", alt: "Un Produit",  caption: "Pâtisserie Recouvreur" },
  { src: "/images/gallery/photo17.jpg", alt: "Un Produit",  caption: "Parc d'attraction Nigloland" },
  { src: "/images/gallery/photo18.jpg", alt: "Un Produit",  caption: "Restaurant Archibald De Prince" },
  { src: "/images/gallery/photo19.jpg", alt: "Un Produit",  caption: "Restaurant Archibald De Prince" },
  { src: "/images/gallery/photo20.jpg", alt: "Un Produit",  caption: "Yumity" },
  { src: "/images/gallery/photo21.jpg", alt: "Un Lieu",     caption: "Restaurant La Table du Belvédère" },
  { src: "/images/gallery/photo22.jpg", alt: "Un Lieu",     caption: "Restaurant La Table du Belvédère" },
  { src: "/images/gallery/photo23.jpg", alt: "Un Produit",  caption: "Restaurant Grünewald Chef's Table" },
  { src: "/images/gallery/photo24.jpg", alt: "Un Produit",  caption: "Boulangerie Au Bon Pain" },
  { src: "/images/gallery/photo25.jpg", alt: "Un Produit",  caption: "Restaurant Les Roses - Casino 2000" },
  { src: "/images/gallery/photo26.jpg", alt: "Un Produit",  caption: "Restaurant Grünewald Chef's Table" },
  { src: "/images/gallery/photo27.jpg", alt: "Un Produit",  caption: "Traiteur Marcotullio" },
  { src: "/images/gallery/photo28.jpg"},
  { src: "/images/gallery/photo29.jpg"},
  { src: "/images/gallery/photo30.jpg"},
  { src: "/images/gallery/photo31.jpg"},
  { src: "/images/gallery/photo32.jpg"},
  { src: "/images/gallery/photo33.jpg"},
  { src: "/images/gallery/photo34.jpg"},
  { src: "/images/gallery/photo35.jpg"},
  { src: "/images/gallery/photo36.jpg"},
  { src: "/images/gallery/photo37.jpg"},
  { src: "/images/gallery/photo38.jpg"},
  { src: "/images/gallery/photo39.jpg"},
  { src: "/images/gallery/photo40.jpg"},
  { src: "/images/gallery/photo41.jpg"},
  { src: "/images/gallery/photo42.jpg"},
  { src: "/images/gallery/photo43.jpg"},
  { src: "/images/gallery/photo44.jpg"},
  { src: "/images/gallery/photo45.jpg"},
  { src: "/images/gallery/photo46.jpg"},
  { src: "/images/gallery/photo47.jpg"},
  { src: "/images/gallery/photo48.jpg"},
  { src: "/images/gallery/photo49.jpg"},
  { src: "/images/gallery/photo50.jpg"},
  { src: "/images/gallery/photo51.jpg"},
  { src: "/images/gallery/photo52.jpg"},
  { src: "/images/gallery/photo53.jpg"},
  { src: "/images/gallery/photo54.jpg"},
  { src: "/images/gallery/photo55.jpg"},
  { src: "/images/gallery/photo56.jpg"},
  { src: "/images/gallery/photo57.jpg"},
  { src: "/images/gallery/photo58.jpg"},
  { src: "/images/gallery/photo59.jpg"},
  { src: "/images/gallery/photo60.jpg"},
  { src: "/images/gallery/photo61.jpg"},
  { src: "/images/gallery/photo62.jpg"},
  // ajoute autant de visuels que tu veux
];

export default function Galerie() {
  useSEO({
  title: "Galerie — Maxime H, photographe culinaire",
  description:
    "Sélection de photographies culinaires réalisées pour des chefs, restaurants, hôtels et traiteurs en France, Luxembourg et Belgique.",
  canonical: `${window.location.origin}/galerie`,
  image: "/images/og-default.jpg",
});

  const [activeImage, setActiveImage] = useState(null);

  // 🔀 Mélange des images (une seule fois à chaque montage de la page)
  const shuffledImages = useMemo(() => {
    const arr = [...IMAGES];
    // Fisher–Yates shuffle (mélange propre)
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }, []);

  const openModal = (image) => {
    setActiveImage(image);
  };

  const closeModal = () => {
    setActiveImage(null);
  };

  return (
    <main className="main">
      <section className="gallery-page">

        {/* Masonry */}
        <div className="gallery">
          {shuffledImages.map((img) => (
            <button
              key={img.src}
              type="button"
              className="gallery-item"
              onClick={() => openModal(img)}
            >
              <img src={img.src} alt={img.alt} loading="lazy" />
            </button>
          ))}
        </div>
      </section>

      {/* Modale */}
      {activeImage && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-inner" onClick={(e) => e.stopPropagation()}>
            <img src={activeImage.src} alt={activeImage.alt} />
            <button className="btn" type="button" onClick={closeModal}>
              Fermer
            </button>
          </div>
        </div>
      )}
    </main>
  );
}